import SeoHead from '@atoms/SeoHead';
import type { ColumnLayoutType } from '@molecules/ColumnLayout/ColumnLayout.types';
import Layout from '@molecules/Layout';
import type { LayoutProps } from '@molecules/Layout/Layout.types';
import { getClient } from '@sanity/lib/getClient';
import type { GetStaticProps } from 'next';
import type { ReactElement } from 'react';

import { TenerifeLandingView } from '@/components/store/TenerifeLandingView/TenerifeLandingView';

interface TenerifePageProps {
  columnLayout?: ColumnLayoutType;
  layoutData: Omit<LayoutProps, 'children'>;
}

const TenerifeLandingPage = ({
  layoutData,
}: TenerifePageProps): ReactElement => (
  <>
    <SeoHead
      metaDescription="Gotowe trasy, 170 sprawdzonych miejsc i praktyczne wskazówki. Zaplanuj wyjazd na Teneryfę szybciej, taniej i bez turystycznych pułapek."
      title="Przewodnik po Teneryfie – zaplanuj wyjazd szybciej i taniej"
      image="/static/images/teneryfa/share.jpg"
      tenerifeSchema
    />
    <Layout {...layoutData} variant="store">
      <TenerifeLandingView />
    </Layout>
  </>
);

export const getStaticProps: GetStaticProps<TenerifePageProps> = async () => {
  const client = getClient();

  const { getAllCategories } = await import('@lib/sanity');
  const { mapLayout } = await import('@mappers/layout');

  const tags = await getAllCategories(client);
  const layoutData = mapLayout(tags);

  return {
    props: {
      layoutData,
    },
  };
};

export default TenerifeLandingPage;
